/* eslint-disable import/prefer-default-export */
import { Signup } from './models';

export const DEFAULT_SIGNUP: Signup = {
  email: '',
  password: '',
  handle: '',
};
